import { useEffect, useRef, useState } from "react";
import _ from "lodash";
import { useLocation, useNavigate } from "react-router-dom";
import ImageLinks from "../../../assets/Images/ImagesLink";
import Footer from "../../../Footer";
import { useDispatch, useSelector } from "react-redux";
import { hide_loader, show_loader } from "../../../actions/app";
import RazorpayUtils from "../../../resources/RazorpayUtils";
import api_requests from "../../../resources/api_requests";
import toast from "react-hot-toast";
import PaymentItem from "../../../modules/PaymenItem";
import { formatCurrencyCountry } from "../../../resources/internationalizationUtils";
import { useTranslation } from "react-i18next";

// const IS_PAYTM_PAGE = window.location.origin.includes("paytm");
const IS_PAYTM_PAGE = false;
const quick_amount = {
  INR: [
    {
      display: "500",
      value: 500,
    },
    {
      display: "1000",
      value: 1000,
    },
    {
      display: "2000",
      value: 2000,
    },
  ],
  IDR: [
    {
      display: "100k",
      value: 100000,
    },
    {
      display: "200k",
      value: 200000,
    },
    {
      display: "500k",
      value: 500000,
    },
  ],
  DEFAULT: [
    {
      display: "500",
      value: 500,
    },
    {
      display: "1000",
      value: 1000,
    },
    {
      display: "2000",
      value: 2000,
    },
  ],
};
const AddFunds = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const { data, from } = location.state || {};
  const [payment_methods, set_payment_methods] = useState([]);
  const init_txn_data = useRef(null);
  const checkout_data = useRef(null);

  const userDetails = useSelector((state) => state.app.user_details);
  const currency_code = userDetails?.currency || "DEFAULT";
  const quick_amounts = quick_amount[currency_code];

  const [input_val, set_input_val] = useState(quick_amounts[0].value);
  const [display_value, set_display_value] = useState(quick_amounts[0].display);

  const { t } = useTranslation();

  const handle_go_back = () => {
    navigate(-1);
  };
  const clear_data = () => {
    set_input_val("");
    init_txn_data.current = null;
    checkout_data.current = null;
  };

  const handle_payment = async () => {
    try {
      dispatch(show_loader());
      const txn_id_responnse = await api_requests.init_wallet_txn({
        amount: input_val,
      });
      if (txn_id_responnse.success) {
        init_txn_data.current = txn_id_responnse.data;
        if (IS_PAYTM_PAGE) {
          on_payment_method_press("paytm_mini_app");
        } else {
          get_payment_methods();
        }
      }
    } catch (error) {
      dispatch(hide_loader());
    }
  };

  const on_payment_method_press = async (method) => {
    try {
      dispatch(show_loader());
      const response = await api_requests.checkout_wallet_recharge(
        init_txn_data.current.transaction_id,
        {
          payment_method: method,
        },
      );
      if (response.success) {
        checkout_data.current = response.data;

        if (IS_PAYTM_PAGE) {
          checkput_paytm_mini_app();
          return;
        }
        if (checkout_data.current.pg.paymentGateway === "paytm") {
          // checkout_paytm();
        } else {
          checkout_razor_pay();
        }
      }
    } catch (error) {
      dispatch(hide_loader());
    }
  };

  const get_payment_methods = async () => {
    try {
      const response = await api_requests.get_wallet_payment_methods(
        init_txn_data.current.transaction_id,
      );
      if (response.success) {
        dispatch(hide_loader());
        set_payment_methods(response.data.methods);
      }
    } catch (error) {
      dispatch(hide_loader());
    }
  };

  const checkout_razor_pay = () => {
    const options = {
      key: checkout_data.current.pg.credential.key_id,
      amount: checkout_data.current.payment.amount * 100,
      currency: "INR",
      name: "Pidge - Recharge",
      description: "For Business Wallet Recharge",
      order_id: checkout_data.current.pg.txnToken,
      prefill: {
        email: checkout_data.current.customer.email,
        contact: checkout_data.current.customer.mobile,
      },
      // theme: { color: tailwindConfig.theme.extend.colors.primary },
      theme: { color: "#492897" },
      modal: {
        escape: false,
        confirm_close: true,
        ondismiss: () => dispatch(hide_loader()),
      },
      config: checkout_data.current.pg.config,
    };
    const razorpay_init_config = {
      options,
      success_callback: payment_success_callback,
      error_callback: payment_error_callback,
    };

    RazorpayUtils.initiate_txn(razorpay_init_config);
  };

  const checkput_paytm_mini_app = () => {
    const requestObject = {
      amount: checkout_data.current.payment.amount?.toFixed(2),
      orderId: checkout_data.current.pg.pid,
      txnToken: checkout_data.current.pg.txnToken,
      mid: checkout_data.current.pg.credential.mid,
    };

    window.JSBridge.call("paytmPayment", requestObject, function (result) {
      alert(JSON.stringify(result));
      payment_success_callback(result);
    });
  };

  const payment_success_callback = (data) => {
    const payload = {
      referenceId: checkout_data.current.pg.referenceId,
      pid: checkout_data.current.pg.pid,
      response: data,
    };
    verify_payment(payload);
  };

  const payment_error_callback = (msg) => {
    dispatch(hide_loader());
    toast.error(msg);
  };

  const verify_payment = async (paylaod) => {
    try {
      const resposne = await api_requests.verify_wallet_recharge(
        init_txn_data.current.transaction_id,
        paylaod,
      );
      if (resposne.success && resposne.data?.status?.success) {
        toast.success("Recharge Successful");
        dispatch(hide_loader());
        clear_data();
        if (from === "cart") {
          navigate("/cart");
        } else {
          navigate(-1);
        }
      }
    } catch (error) {
      dispatch(hide_loader());
    }
  };

  const format_currency_value = (val) => {
    return {
      amount: formatCurrencyCountry(Number(val || 0), currency_code)
        ?.mainAmount,
      currency: formatCurrencyCountry(val, currency_code)?.currency,
      currency_at_start: formatCurrencyCountry(val, currency_code)
        ?.is_currency_at_start,
    };
  };

  const handle_input_change = (e) => {
    const digits = e.target.value.replace(/\D/g, "");

    if (digits === "") {
      set_input_val("");
      set_display_value("");
      return;
    }

    if (Number(digits) > 100000) return;

    set_input_val(digits);

    const formatted = format_currency_value(digits).amount;
    set_display_value(formatted);
  };
  return (
    <div className="relative min-h-screen flex flex-col">
      <div className="">
        <div
          className="flex items-center gap-2 px-6 py-6"
          onClick={handle_go_back}
        >
          <img src={ImageLinks.chevron_right} className="w-[18px] h-[19px]" />
          <p className="font-custom text-sm font-semibold text-dark_black">
            {t('add_funds')}
          </p>
        </div>
        <div className="h-[64px] px-6 py-4 bg-accents flex justify-between items-center">
          <div>
            <p className="font-custom font-semibold text-xs text-primary">
              {t("available")}
            </p>
            <p className="font-custom font-semibold text-base text-dark_black">
              {t("balance")}
            </p>
          </div>

          <p className="font-custom font-semibold text-base">
            {formatCurrencyCountry(data?.balance, currency_code).formatedAmount}
          </p>
        </div>
        <div className="flex flex-col items-center justify-center mt-4">
          <p className="font-custom font-semibold text-dark_gray text-sm mt-8 my-2">
            {t("enter_amount")}
          </p>
          <div className="px-2 border-b border-light_gray flex justify-center items-baseline gap-2 mt-3">
            {format_currency_value(0).currency_at_start && (
              <p className="font-custom font-semibold text-xl">
                {format_currency_value(0).currency}
              </p>
            )}
            <input
              type="text"
              className="text-[36px] grow border-none text-dark_black font-bold focus:outline-none focus:ring-0 focus:border-transparent"
              value={display_value}
              onChange={handle_input_change}
              disabled={!_.isEmpty(payment_methods)}
              style={{
                maxWidth: "182px",
                width: "auto",
                overflow: "hidden", // Hides overflowed content
                whiteSpace: "nowrap", // Prevents text from wrapping to the next line
              }}
            />
            {!format_currency_value(0).currency_at_start && (
              <p className="font-custom font-semibold text-xl">
                {format_currency_value(0).currency}
              </p>
            )}
          </div>
          <div className="flex gap-2 mb-2 mt-4">
            {_.map(quick_amounts, (amount) => (
              <div
                className={`h-[20px] w-[70px] flex items-center justify-center border-${input_val == amount.value ? "secondary" : "[#7953D233]"} border-[1px] rounded-2xl`}
                onClick={() => {
                  if (!_.isEmpty(payment_methods)) return;
                  set_input_val(amount.value);
                  set_display_value(amount.display);
                }}
              >
                <p
                  className={`font-custom font-medium text-${
                    input_val == amount.value ? "secondary" : "gray"
                  } text-[10px]`}
                >
                  {formatCurrencyCountry(amount.value, currency_code).currency}{" "}
                  {amount.display}
                </p>
              </div>
            ))}
          </div>
          {_.isEmpty(payment_methods) && (
            <button
              type="submit"
              className="mt-10 font-custom btn btn-block bg-primary text-white w-[276px] rounded-[30px] "
              disabled={!input_val}
              onClick={handle_payment}
            >
              {`${t('pay')} ${formatCurrencyCountry(input_val, currency_code)?.currency} ${display_value}`}
            </button>
          )}
        </div>
      </div>
      {payment_methods.length > 0 && (
        <div
          className="fixed inset-0 bg-black/40 z-40"
          onClick={() => set_payment_methods([])}
        ></div>
      )}
      {payment_methods.length > 0 && (
        <>
          <div
            className="fixed inset-0 bg-black/40 z-40"
            onClick={() => set_payment_methods([])}
          ></div>
          <div className="z-50 absolute bottom-0 bg-white w-full rounded-t-xl">
            <div className="rounded-t-xl bg-[#F2EEF8] flex justify-between items-center py-6 px-10">
              <p className="font-custom text-base font-semibold text-[#1E1E1E]">
                {t('amount_to_be_paid')}
              </p>
              <span className="font-custom text-[20px] font-semibold text-[#1E1E1E]">
                {
                  formatCurrencyCountry(input_val, currency_code)
                    ?.formatedAmount
                }
              </span>
            </div>
            <div className="overflow-auto p-6 pt-3">
              {_.map(payment_methods, (item, index) => (
                <PaymentItem
                  key={`payment_method${index}`}
                  item={item}
                  onClick={() => {
                    on_payment_method_press(item.key);
                  }}
                />
              ))}
            </div>
          </div>
        </>
      )}
      <Footer bottom={0} />
    </div>
  );
};

export default AddFunds;
